import { getFullUrl } from 'hubspot-url-utils'; // @ts-expect-error Untyped module

import Cookies from 'js-cookie';
import { prefetchPage } from 'prefetcher/utils/prefetchPage';
import { ExperimentIdentifier } from '../experiments/ExperimentIdentifier';
import { getQueryParam } from '../routing/getQueryParam';
import { Data } from '../signup-data/DATA';
import { setHublet, setIsNewUser, setNewPortalCreated } from '../store/app/action-creators';
import { fetchExperiments } from '../store/experiments/action-creators';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import AnonymousUsageTrackerContainer from '../tracking/AnonymousUsageTrackerContainer';
import UsageTrackerContainer from '../tracking/UsageTrackingContainer';
import { Step } from '../views/Step';
import { setNewPortalId } from './setNewPortalId';
export const handleSignupSuccess = (response, dispatch, getState) => {
  const state = getState();
  const {
    hubId,
    userCreated,
    region: hublet
  } = response;
  const postAccountCreation = getPostAccountCreationSteps(state);

  if (AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled) {
    UsageTrackerContainer.setProperties({
      email: getSignupDataValue(state, Data.Email)
    });
    const messagesUtk = Cookies.get('messagesUtk') || getQueryParam('messagesUtk');
    UsageTrackerContainer.setProperties({
      messagesUtk
    });
  }

  setNewPortalId({
    hubId,
    hublet
  }, dispatch);
  dispatch(setHublet(hublet));
  dispatch(setNewPortalCreated());
  dispatch(setIsNewUser(userCreated));

  if (postAccountCreation.length >= 1 && postAccountCreation[0] !== Step.MobileAppPrompt) {
    dispatch(fetchExperiments({
      identifierPhase: ExperimentIdentifier.PortalId
    }));
  }

  prefetchPage('setup-guide-ui-prefetch', {
    url: getFullUrl('app', {
      hubletOverride: hublet
    })
  });
};